import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';
import { dataFileUrl, saveFileUrl } from '../../common/api';
import ActionButtons from '../../common/ActionButtons';
import { Icon } from '../../common/AppShell';
import Loader from '../../common/Loader/Loader';
import Switch from '../Switch/Switch';
import '../../index.css';

const Delivery = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    paidDelivery: false,
    deliveryStart: '',
    deliveryEnd: '',
    minDeliveryAmount: '',
    deliveryCost: '',
    promotion: false,
    promotionCount: 10,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${dataFileUrl('delivery')}?t=${Date.now()}`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error('Ошибка загрузки данных.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]:
        type === 'checkbox'
          ? checked
          : ['deliveryStart', 'deliveryEnd', 'minDeliveryAmount', 'deliveryCost', 'promotionCount'].includes(name)
            ? Number(value)
            : value,
    }));
  };

  const saveData = () => {
    axios
      .put(saveFileUrl('delivery'), data)
      .then(() => toast.success('Данные успешно обновлены!'))
      .catch((error) => {
        console.error('Error saving data:', error);
        toast.error('Ошибка обновления данных.');
      });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <section className="screen-stack">
      <div className="form-card">
        <div className="form-card-title">
          <Icon name="local_shipping" />
          <div>
            <h2>Доставка</h2>
            <p>Часы, минимальная сумма и скидки</p>
          </div>
        </div>

        <div className="setting-row">
          <div>
            <strong>Платная доставка</strong>
            <span>{data.paidDelivery ? 'Стоимость применяется' : 'Доставка бесплатная'}</span>
          </div>
          <Switch value={data.paidDelivery} name="paidDelivery" onColor="#4DD863" handleToggle={handleChange} />
        </div>

        <div className="field-grid">
          <label className="app-field">
            <span>Начало</span>
            <input
              type="number"
              name="deliveryStart"
              placeholder="Начало доставки"
              onChange={handleChange}
              value={data.deliveryStart || ''}
              inputMode="numeric"
            />
          </label>
          <label className="app-field">
            <span>Конец</span>
            <input
              type="number"
              name="deliveryEnd"
              placeholder="Конец доставки"
              onChange={handleChange}
              value={data.deliveryEnd || ''}
              inputMode="numeric"
            />
          </label>
        </div>

        <label className="app-field">
          <span>Минимальная сумма заказа</span>
          <input
            type="number"
            name="minDeliveryAmount"
            placeholder="Минимальная сумма"
            onChange={handleChange}
            value={data.minDeliveryAmount || ''}
            inputMode="numeric"
          />
        </label>

        <label className={`app-field ${data.paidDelivery ? '' : 'muted'}`}>
          <span>Стоимость доставки</span>
          <input
            type="number"
            name="deliveryCost"
            disabled={!data.paidDelivery}
            placeholder="Стоимость доставки"
            onChange={handleChange}
            value={data.deliveryCost || ''}
            inputMode="numeric"
          />
        </label>

        <div className="setting-row">
          <div>
            <strong>Скидка</strong>
            <span>{data.promotion ? `${data.promotionCount}%` : 'Не применяется'}</span>
          </div>
          <Switch value={data.promotion} name="promotion" onColor="#4DD863" handleToggle={handleChange} />
        </div>

        <label className={`app-field ${data.promotion ? '' : 'muted'}`}>
          <span>Сумма скидки</span>
          <input
            type="number"
            name="promotionCount"
            disabled={!data.promotion}
            placeholder="Сумма скидки"
            onChange={handleChange}
            value={data.promotionCount || ''}
            inputMode="numeric"
          />
        </label>
      </div>

      <ActionButtons onBack={() => navigate('/more')} onSave={saveData} />
    </section>
  );
};

export default Delivery;
